import angular from 'angular';
import { paginationComponent } from './paginationComponent';

angular.module('sh.pagination', []).component('shPagination', paginationComponent());
